export default {
    metaTitle: 'Calendar',
    categories: {
        panelTitle: 'Calendar settings',
        title: 'Categories',
        subtitle: 'Organize your appointments and events with colored categories.',
        empty: 'No categories yet',
        emptyText: 'Click “Add category” to create your first one.',
        namePlaceholder: 'Category name...',
        add: 'Add category',
        customColor: 'Custom color',
        field: 'Category',
        all: 'All categories',
        googleConnected: 'Sync active',
        reconnect: 'Reconnect',
        connectGoogle: 'Connect Google Calendar',
        typeGeneral: 'Event',
        typeAppointment: 'Appointment',
        clearFilter: 'Clear',
        filtersTitle: 'Calendar filters',
        filtersTooltip: 'View / filters',
        filtersHint: 'With none selected, everything shows.',
        viewTitle: 'View',
        showTime: 'Show event time',
        googleEvents: 'Google Calendar events',
        googleDescription: 'Sync your appointments with your Google Calendar.',
        twoWaySync: 'Two-way sync',
        twoWaySyncHint: 'Moving or deleting an appointment in Google Calendar moves or cancels it in athlisis too.',
    },
    google: {
        panelTitle: 'Google Calendar event',
        notifyCheckbox: 'Email the guests about the change',
        timesOnly: 'Only the time changes from here. Everything else changes in Google Calendar.',
        openInGoogle: 'Open in Google Calendar',
        findClient: "Find the client's tab",
        dragOnly: 'Events longer than a day move by dragging them on the calendar.',
        notifyTitle: 'Email the guests?',
        notifyBody: 'Google will email everyone invited about the new time.',
        notify: 'Send',
        dontNotify: "Don't send",
        reconnect: 'Google Calendar needs reconnecting from the calendar settings.',
    },
    googleSync: {
        title: 'Two-way sync with Google Calendar',
        inviteIntro: 'Changes you make to your appointments in Google Calendar can now carry over to athlisis automatically.',
        intro: 'Changes you make to your appointments in Google Calendar carry over to athlisis automatically.',
        moveLabel: 'Moved in Google Calendar:',
        move: 'the appointment moves in athlisis too.',
        deleteLabel: 'Deleted from Google Calendar:',
        delete: 'the appointment is cancelled in athlisis. If it\'s restored in Google Calendar, it becomes active again in athlisis too.',
        past: 'Completed appointments aren\'t cancelled when you delete them from Google Calendar.',
        paymentMark: 'Appointments you\'ve marked as paid or unpaid don\'t change from Google Calendar.',
        inviteHint: 'You can also turn two-way sync on later in the calendar settings.',
        hint: 'You can turn two-way sync off in the calendar settings.',
        turnOn: 'Turn on',
        later: 'Not now',
        ok: 'Got it',
    },
    newFeature: 'New',
    cancelled: 'Cancelled',
    approved: 'Confirmed',
    notesMore: 'more',
    notesLess: 'less',
    markAsCancelled: 'Mark as cancelled',
    revokeCancelled: 'Mark as non-cancelled',
    viewProfile: 'Client profile',
    kinds: {
        title: 'Type',
        customer: 'Client appointment',
        general: 'Event / Activity'
    },
    title: 'Title',
    startTime: 'Start time',
    duration: 'Duration',
    endTime: 'End time',
    minutes: '{time} minutes',
    googleMeet: 'Online meeting (Google Meet)',
    addCustomer :'Create new client',
    startGoogleMeet: 'Start meeting (Google meet)',
    create: 'Add appointment',
    update: 'Update appointment',
    delete: 'Delete appointment',
    errors: {
        missingCustomer: 'Please select a client or change the type.',
        missingDateTime: 'Please select both start and end date/time.',
        invalidTime: 'Times must be in HH:mm format (e.g. 09:30).',
        invalidMobileNumberForSms: 'You cannot create an appointment with a scheduled SMS when the client\'s mobile number is not valid. Please disable SMS or update the number in the client\'s profile.',
        missingMobileNumberForSms: 'You cannot create an appointment with a scheduled SMS when the client does not have a mobile number registered. Please disable SMS or add a valid number in the client\'s profile.'
    },
    updateMobileNumber: 'Update mobile number',
    untitled: 'Untitled event',
    findTab: '(click to find client\'s tab)',
    onlyWithGoogle: 'This is only applicable if you have connected your Google Calendar.',
    allDay: 'All Day',
    timezoneRequired: 'Timezone Required',
    timezoneDescription: 'Please select your timezone to ensure all calendar events are displayed with the correct times.',
    timezoneDifferentFromSystem: 'Different from system timezone ({system})',
    toggleTime: 'Show/Hide time',
    sms: {
        segments: '{count} SMS per reminder',
        title: 'SMS Reminder',
        description: 'Send an SMS reminder for this appointment',
        reminder: {
            hoursBefore: 'Hours before appointment',
            description: 'When to send the reminder before the appointment'
        },
        noSubscription: {
            title: 'SMS Reminders Available',
            description: 'Subscribe to SMS service to send automatic reminders to your clients',
            cta: 'View SMS Plans'
        }
    }
}
